import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {RouterLinks} from '../../../constants';
import {DocumentId} from '../../models/document.modal';

declare var jQuery: any;

@Component({
    selector: 'app-doc-side-nav',
    templateUrl: './doc-side-nav.component.html',
    styleUrls: ['./doc-side-nav.component.scss'],
    standalone: false
})
export class DocSideNavComponent implements OnInit, OnDestroy {
  @Input() documentId: DocumentId;

  public DocumentId = DocumentId;
  RouterLinks = RouterLinks;

  constructor() {
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    jQuery('#mobile-details').modal('hide');
  }
}
